import { useState } from 'react';
import './ProspectNavPanel.css';

const STAGE_FILTERS = [
  { key: 'ALL',      label: 'All' },
  { key: 'PRELIMINARY_REVIEW',        label: 'S1' },
  { key: 'INITIAL_REVIEW_DISCUSSION', label: 'S2' },
  { key: 'DOCUMENT_COLLECTION',       label: 'S3' },
  { key: 'STRATEGY',                  label: 'S4-5' },
  { key: 'EXECUTION',                 label: 'S6' },
  { key: 'STALLED',                   label: '⏰' },
];

const STAGE_COLORS = {
  PRELIMINARY_REVIEW:        '#5a7a85',
  INITIAL_REVIEW_DISCUSSION: '#004358',
  DOCUMENT_COLLECTION:       '#d97706',
  FINAL_WEALTH_STRATEGY:     '#7c3aed',
  FINAL_STRATEGY_DISCUSSION: '#4338ca',
  EXECUTION:                 '#16a34a',
};

function stageShortLabel(stageKey) {
  const labels = {
    PRELIMINARY_REVIEW:        'S1 — Prelim Review',
    INITIAL_REVIEW_DISCUSSION: 'S2 — Initial Discussion',
    DOCUMENT_COLLECTION:       'S3 — Doc Collection',
    FINAL_WEALTH_STRATEGY:     'S4 — Final Strategy',
    FINAL_STRATEGY_DISCUSSION: 'S5 — Final Discussion',
    EXECUTION:                 'S6 — Execution',
  };
  return labels[stageKey] || stageKey;
}

export default function ProspectNavPanel({ prospects, activeFilter, onFilterChange, selectedId, onSelect }) {
  const [search, setSearch] = useState('');

  function handleSearchChange(e) {
    setSearch(e.target.value);
  }

  function handleFilterClick(key) {
    if (activeFilter === key) {
      onFilterChange('ALL');
    } else {
      onFilterChange(key);
    }
  }

  function handleRowClick(prospect) {
    onSelect(prospect);
  }

  const filtered = (prospects || []).filter(p => {
    const matchesSearch = !search || (p.name || '').toLowerCase().includes(search.toLowerCase());
    let matchesFilter = false;
    if (activeFilter === 'ALL') {
      matchesFilter = true;
    } else if (activeFilter === 'STRATEGY') {
      matchesFilter = p.current_stage_key === 'FINAL_WEALTH_STRATEGY' || p.current_stage_key === 'FINAL_STRATEGY_DISCUSSION';
    } else if (activeFilter === 'STALLED') {
      matchesFilter = (p.days_in_stage || 0) > 30;
    } else {
      matchesFilter = p.current_stage_key === activeFilter;
    }
    return matchesSearch && matchesFilter;
  });

  return (
    <div className="pnp__panel">
      <div className="pnp__search-wrap">
        <input
          className="pnp__search"
          type="text"
          placeholder="Search by name..."
          value={search}
          onChange={handleSearchChange}
        />
      </div>

      <div className="pnp__filters">
        {STAGE_FILTERS.map(f => (
          <button
            key={f.key}
            className={`pnp__filter-chip ${activeFilter === f.key ? 'pnp__filter-chip--active' : ''}`}
            onClick={() => handleFilterClick(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="pnp__list">
        {filtered.length === 0 && (
          <div className="pnp__empty">No prospects found</div>
        )}
        {filtered.map(prospect => {
          const isStalled = (prospect.days_in_stage || 0) > 30;
          const isSelected = prospect.id === selectedId;
          const stageColor = STAGE_COLORS[prospect.current_stage_key] || '#5a7a85';

          return (
            <div
              key={prospect.id}
              className={[
                'pnp__row',
                isSelected ? 'pnp__row--selected' : '',
                isStalled  ? 'pnp__row--stalled' : '',
              ].filter(Boolean).join(' ')}
              onClick={() => handleRowClick(prospect)}
            >
              <div className="pnp__row-name">
                {isStalled && <span className="pnp__stalled-icon">⚠</span>}
                {prospect.name || '—'}
              </div>
              <div className="pnp__row-meta">
                <span
                  className="pnp__stage-badge"
                  style={{ backgroundColor: stageColor + '18', color: stageColor, borderColor: stageColor + '40' }}
                >
                  {stageShortLabel(prospect.current_stage_key)}
                </span>
                <span className="pnp__days">Day {prospect.days_in_stage ?? 0}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
